import { BreakpointObserver } from '@angular/cdk/layout';

import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal, WritableSignal } from '@angular/core';
import { SCREENS } from '@portal/ui-common';
import { ServiceCode } from '@shared/ui-service';
import { ServiceImageComponent } from '../service-image/service-image.component';

const CSL_IMPORTS = [ServiceImageComponent];
@Component({
  selector: 'csl-service-details-header',
  standalone: true,
  imports: [...CSL_IMPORTS],
  templateUrl: './service-details-header.component.html',
  styleUrl: './service-details-header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block w-full',
  },
})
export class ServiceDetailsHeaderComponent implements OnInit {
  private readonly breakpointObserver = inject(BreakpointObserver);

  serviceCode$$ = input.required<ServiceCode>();
  serviceType$$ = input.required<string>();
  serviceDescription$$ = input.required<string>();
  serviceDetailsDescription$$ = input.required<string[]>();

  isCollapsed$$: WritableSignal<boolean> = signal(false);
  isCollapsedIconVisible$$: WritableSignal<boolean> = signal(false);

  toggleCollapse(): void {
    this.isCollapsed$$.update((val) => !val);
  }

  ngOnInit(): void {
    if (this.breakpointObserver.isMatched(`(max-width: ${SCREENS.md}px)`)) {
      this.isCollapsedIconVisible$$.set(true);
      this.isCollapsed$$.set(true);
    }
  }
}
